import { useState, useEffect } from "react";
import { buscarInfoUsuarioByCotaUsuario } from "../../../services/buscarInfoUsuarioByCotaUsuarioService";
import { buscarLeadsByIdService } from "../../../services/buscarLeadsByIdService";

export const useBuscarLead = (leadId: number, isModalOpen: boolean) => {
  const [lead, setLead] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      if (!isModalOpen || !leadId) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const data = await buscarLeadsByIdService(leadId);
        setLead(data);
      } catch (error) {
        console.error("Erro ao buscar lead:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [isModalOpen, leadId]);

  return { lead, isLoading };
};
